import { useEffect, useState } from 'react';

/**
 * Returns `value`, or - while it is null - the last non-null value seen.
 *
 * A profile section's side panel closes by setting its section to null, but it
 * animates out first; without this its title and fields would blank out
 * mid-transition (MYN-217).
 *
 * @param value - the current value, null when cleared.
 * @param initial - returned until a non-null value has been seen.
 * @returns the current or last non-null value.
 */
export function useRetainedValue<T>(value: T | null, initial: T): T {
  const [last, setLast] = useState<T>(value ?? initial);
  useEffect(() => {
    if (value !== null) setLast(value);
  }, [value]);
  return value ?? last;
}
